const translations = {
  "en": {
    "The money person you've been doing without.": "The money person you've been doing without."
  },
  "zh-tw": {
    "The money person you've been doing without.": "你一直以來所缺少的理財專家。"
  }
};

export default translations;
